import { useTranslation } from 'react-i18next'

import { useFetchCustomerCoupons } from '@entities/Loyalty'

import { useAuth } from '@features/auth'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { CouponsSlider } from '@widgets/coupons-slider'

export default function CouponsBlock () {
  const { t } = useTranslation()
  const { isAuthorized, requireRegistration} = useAuth()
  
  const { 
    coupons, 
    loading
  } = useFetchCustomerCoupons({
    skip: !isAuthorized || requireRegistration
  })

  // Не показываем блок для неавторизованных пользователей
  if (!isAuthorized || requireRegistration) {
    return null
  }

  return (
    <div className={styles.root__coupons}>
      <h3 className={styles.coupons__title}>
        {t('coupons', 'Купоны')}
      </h3>
      <CouponsSlider 
        coupons={coupons} 
        loading={loading} 
      />
    </div>
  )
}